@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/oldStyles/_utils.scss";

.wrapper {
  @include utils.scrollbar;
  overflow: auto;
  padding-block-start: sizes.$s6;
  border-block-start: 1px solid colors.$gray30;
  padding-block-end: sizes.$s6;
  border-block-end: 1px solid colors.$gray30;

  details {
    padding-inline-start: 20px;
    margin-block: sizes.$s3;

    summary::-webkit-details-marker {
      display: none;
    }

    summary {
      list-style: none;

      display: flex;
      align-items: center;

      a {
        flex: 1;
        display: flex;
        align-items: center;
        height: 2 * fonts.$mid;
        gap: sizes.$s4;
        margin-inline-end: sizes.$s6;
        margin-inline-start: -(sizes.$s4);
        padding: 0 sizes.$s4;
        border-radius: sizes.$s4;
        @include fontStyles.body2-book;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        svg {
          color: colors.$gray60;
        }

        // Override Link component
        > svg:first-child:not(:only-child) {
          margin: 0;
        }

        span {
          width: sizes.$s16;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:hover {
          background-color: colors.$gray30;

          svg {
            color: initial;
          }
        }
      }
    }

    .toggle {
      margin-inline-end: sizes.$s3;
      padding-inline: sizes.$s3;
      margin-inline-start: -(sizes.$s3);
      z-index: 1;

      svg {
        transition: transform 150ms ease-in-out;
      }
    }

    .toggle.noChildren {
      visibility: hidden;
    }

    .toggle.isOpen {
      svg {
        transform: rotate(90deg);
      }
    }
  }

  & > details {
    padding-inline-start: sizes.$s3;

    & > summary {
      a {
        height: sizes.$s8;
      }
    }
  }

  & details.selected > summary a {
    background-color: colors.$gray30;

    svg {
      color: initial;
    }

    &:hover {
      background-color: colors.$gray40;
    }
  }
}
